import axios from "axios"
import { VehicleInspection } from "../Types";
import { arrayBuffer } from "stream/consumers";

const VehicleInspectionService ={
    list:{
        getVegicleInspection:(tenant:string, data:any)=>{
            return axios.get("./masterdatavehicle/inspection",{params:{tenant,...data}}).then(response=>response.data)
        },
        exportVehicleInspection:(tenant:string, vehicleId:any, data:VehicleInspection.VehicleInspectionFilter)=>{
          return axios.get(`./masterdatavehicle/inspection/vehicle/${vehicleId}/excel`,{params:{tenant,...data},responseType:"arraybuffer"})
        },
        getVehicleInspectionById:(tenant:string,vehicleId:number) =>{
            return axios.get(`./masterdatavehicle/inspection/vehicle/${vehicleId}`,{params:{tenant:tenant}}).then(response=>response.data)
        }
    },
    delete:{
        deleteVehicle:(tenant:string,id:number)=>{
            return axios.delete(`./masterdatavehicle/inspection/${id}`,{params:{tenant:tenant}}).then(response=>response.data)
        }
    },
    post:{
        createVehicle:(tenant:string,vehicle:any) =>{
            return axios.post("./masterdatavehicle/inspection",vehicle, {params:{tenant:tenant}})
        }
    },
    update:{
        updateVehicle:(tenant:string,id:number,vehicle:any) =>{
            return axios.put(`./masterdatavehicle/inspection/${id}`,vehicle,{params:{tenant:tenant}})
        }
    }

}
export default VehicleInspectionService;